<template>
  <div class="login pr" :style="`background-image: url(${$store.state.user.backgroundImage});`">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <h3 class="title fweight500 fsize24">登录</h3>
      <el-form-item prop="phonenumber">
        <el-input
          v-model="loginForm.phonenumber"
          type="text"
          auto-complete="off"
          placeholder="请输入手机号"
          maxlength="11"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="请输入登陆密码（6-16位字母或数字）"
          @keyup.enter.native="handleLogin"
        >
        </el-input>
      </el-form-item>
      <!-- <el-form-item prop="code" v-if="captchaEnabled">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="handleLogin"
        >
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item> -->
      <!-- <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox> -->
      <div class="marginBom30 overflow" style="margin-top: 5px">
        <router-link class="link-type fcolor_darkBlue fr" :to="'/retrieve'"
          >忘记密码？</router-link
        >
      </div>
      <el-form-item style="width: 100%">
        <el-button
          class="marginBom30"
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <div class="" style="float: right;">
          <span>还没有账号，</span><router-link
            class="link-type fcolor_darkBlue"
            :to="'/register'"
            >立刻注册</router-link
          >
          <el-button
            class="marginLt10"
            size="medium"
            type="primary"
            style="height: 30px;line-height: 30px; padding: 0 10px;"
            @click="openPage('/management/login')"
            >管理员登录</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <!-- <div class="brand-footer">
      <span class="fcolor_gray2">Copyright © 浙江大学医学院附属邵逸夫医院</span>
    </div> -->
  </div>
</template>

<script>
import { login, getInfo } from "@/utils/api";
import { setToken } from "@/utils/auth";
import Cookies from "js-cookie";

import axios from 'axios';
let CancelToken = axios.CancelToken;
export default {
  name: "Login",
  data() {
    return {
      // codeUrl: "",
      loginForm: {
        phonenumber: "",
        password: "",
        userType:'1'
        // rememberMe: false,
        // code: "",
        // uuid: "",
      },
      loginRules: {
        phonenumber: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        // code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.source = CancelToken.source();
  },
  methods: {
    openPage(url){
      location.href= location.origin+url
    },
    handleLogin(e) {
      this.$refs.loginForm.validate((valid) => {
        console.log(valid, this.loginForm);
        if (valid) {
          this.loading = true;
          this.loginForm.cancelToken = this.source.token;
          login(this.loginForm)
            .then((res) => {
              if (res.code == 200) {
                setToken(res.token);
                getInfo().then(userInfo=>{
                  localStorage.setItem('userInfo',JSON.stringify(userInfo.user))
                })
                setTimeout(() => {
                  this.$router.push("/add/index");
                }, 500);
              }
            })
            .catch(() => {
              this.loading = false;
            });
          // this.source.cancel("异常信息,选填")
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.brand-footer{
  background-color: transparent !important;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-size: cover;
}
.title {
  margin: 0px auto 48px auto;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
}
.el-form-item {
  margin-bottom: 0;
}
.el-form-item:first-of-type {
  margin-bottom: 30px;
}
.flex-xCenter {
  line-height: 19px;
}
.login-form {
  border-radius: 6px;
  box-sizing: border-box;
  background: #ffffff;
  position: absolute;
  right: 235px;
  top: 163px;
  width: 400px;
  padding: 30px 40px;
  .el-button {
    height: 48px;
  }
  .el-input {
    height: 40px;
    input {
      height: 40px;
    }
  }
  .input-icon {
    height: 40px;
    width: 14px;
    margin-left: 2px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.login-code-img {
  height: 38px;
}
</style>
